<template>
  <div>
    <div class="background-darker-blue py-12">
      <h1 class="tfb-title-text-large text-center">Auto Quote</h1>
      <v-container class="tfb-smallest-container tfb-quote-box pa-5 my-8">
        <v-row>
          <v-col cols="12"
                 class="py-1">
              Based on the information provided, this quote needs assistance from an agent.
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12"
                 class="py-1">
            Click here to <router-link :to="{ name: 'countyLookup'}" hreflang="en-us">find a local agent</router-link>.
          </v-col>
        </v-row>
        <v-row v-if="agreementNumber != ''">
          <v-col cols="12"
                 class="py-1 text-body-2">
            Quote#: {{agreementNumber}}
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'AutoQuoteContactAgent',
    computed: {
      metaDescription() {
        return 'Looking for an auto insurance quote? Use our online tool to learn how Texas Farm Bureau Insurance can help provide coverage for your precious ride.';
      },
      metaPageTitle() {
        return 'Agent Assistance | Auto Rate Quote';
      },
      metaUrl() {
        return `${process.env.VUE_APP_ROOT_URI}/quotes/auto/contact-agent`;
      },
      agreementNumber() {
        try {
          return this.$store.getters['quotes/agreementNumber'];
        } catch (error) {
          return '';
        }
      },
    },
    async mounted() {
      this.$store.dispatch('app/setIsLoading', false);
    },
  };
</script>
<style lang="scss">

</style>
